import { fields } from "@monorepo/utils/src/variables/projectsData/docTypeView/fields";

export const currentFilters = (): Record<string, unknown> => ({
  [fields.FILTER_SECTION]: [],
  [fields.NAME]: "",
  [fields.ID]: "",
});
